import {useSession} from 'next-auth/react'
import {FC} from 'react'

import {Avatar, AvatarSize} from '@/components/common/content/Avatar'
import {Link} from '@/i18n'
import {theme} from '@/theme/theme'
import {getAvatarInitials} from '@/utils/avatar'
import {useUser} from '@/utils/data-fetchers/useUser'
import {routeTo} from '@/utils/router'

type UserAvatarProps = {
  isClickable?: boolean
}

export const UserAvatar: FC<UserAvatarProps> = ({isClickable = true}) => {
  const {data: session} = useSession()
  const userId = session?.user?.id as string
  const {data: user} = useUser(userId)

  const userEmail = user?.email
  const userFullName =
    user?.profile?.firstname && user?.profile?.lastname
      ? `${user?.profile.firstname} ${user?.profile.lastname}`
      : undefined
  const userName = userFullName ?? userEmail
  const avatarInitials = userName ? getAvatarInitials(userName, 2) : '?'

  const avatar = (
    <Avatar
      initials={avatarInitials}
      backgroundColor={theme.palette.green[500]}
      size={AvatarSize.large}
    />
  )

  return isClickable ? <Link href={routeTo.portal.home()}>{avatar}</Link> : avatar
}
